import { token } from '@cp/shared/di';

export const TRY_FOR_FREE = token<() => Promise<unknown>>('BurgerMenu: try for free');
